import React, { useEffect, useMemo, useState } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import ColumnSelectGrid from "./ColumnSelectGrid";

const ColumnSelectModal = ({
  open,
  onClose,
  columns = [],
  title = "Selecione uma coluna",
  loadingColumns,
  selectedColumnId = null,
  onSelect,
}) => {
  const theme = useTheme();

  const rows = useMemo(
    () => (Array.isArray(columns) ? columns : []),
    [columns],
  );

  const [selectionModel, setSelectionModel] = useState([]);

  const selectedRow = rows.find((r) => r.id === selectionModel[0]);

  useEffect(() => {
    if (open && selectedColumnId) {
      setSelectionModel([selectedColumnId]);
    }

    if (!open) {
      setSelectionModel([]);
    }
  }, [open, selectedColumnId]);

  const handleSelect = () => {
    if (!selectedRow) return;
    onSelect?.(selectedRow);
    onClose?.();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "96vw", sm: "90vw", md: "70vw" },
          height: { xs: "96vh", sm: "80vh" },
          backgroundColor: "#F7F7FC",
          borderRadius: 2,
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* HEADER */}
        <Box
          px={3}
          py={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: 500,
              color: "#545454",
            }}
          >
            {title}
          </Typography>

          <CloseOutlined
            onClick={onClose}
            sx={{ cursor: "pointer", color: theme.palette.custom.gray[300] }}
          />
        </Box>

        {/* BODY */}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",

            "&::-webkit-scrollbar": {
              width: 10,
              height: 10,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#C7C7CC",
              borderRadius: 10,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },

            scrollbarWidth: "thin",
            scrollbarColor: "#C7C7CC transparent",
          }}
        >
          {loadingColumns ? (
            <ColumnSelectGrid
              loadingColumns={true}
              rows={[]}
              selectionModel={selectionModel}
              onSelectionChange={setSelectionModel}
            />
          ) : rows.length === 0 ? (
            <Typography sx={{ color: theme.palette.custom.gray[500], mt: 2 }}>
              Nenhuma coluna disponível.
            </Typography>
          ) : (
            <ColumnSelectGrid
              loadingColumns={false}
              rows={rows}
              selectionModel={selectionModel}
              onSelectionChange={setSelectionModel}
            />
          )}
        </Box>

        <Box
          px={3}
          py={2}
          display="flex"
          justifyContent="flex-end"
          gap={2}
          borderTop="1px solid #E5E5EF"
          bgcolor="#F7F7FC"
        >
          <Button variant="outlined" onClick={onClose}>
            Cancelar
          </Button>

          <Button
            variant="contained"
            disabled={!selectedRow}
            onClick={handleSelect}
            sx={{
              backgroundColor: theme.palette.custom.purple[500],
              "&:hover": { backgroundColor: theme.palette.custom.purple[700] },
            }}
          >
            Selecionar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ColumnSelectModal;
